// extracted by mini-css-extract-plugin
export default {"feature":"style_feature__PU5Bi","dot":"style_dot__K71l7","icon":"style_icon__piB5H","text":"style_text__ONOjU"};